/**
 *
 *
 * Работает только у джоина с "карточками"
 *
 */

const ACTIVE: string = 'active';
const OPENED: string = 'opened';
const SHOW: string = 'show';
const HIDE: string = 'hide';

export default class HTMLElement
{
	private ogoForm: HTMLFormElement;
	private ogoSubmit: HTMLButtonElement;
	
	private ogoLabel: HTMLButtonElement;
	private otherLabel: NodeList;
	
	private cards: NodeList;
	private currentCard: HTMLDivElement;
	private inputTitle: HTMLInputElement;
	private inputSite: HTMLInputElement;
	private inputId: HTMLInputElement;
	private inputEmail: HTMLInputElement;
	
	private inputMainEmail: HTMLInputElement;
	private inputMainLogin: HTMLInputElement;
	private inputMainPass: HTMLInputElement;
	
	public constructor()
	{
		this.ogoForm = <HTMLFormElement>document.querySelector( 'form.ogoshift' );
		
		if ( this.ogoForm !== null )
		{
			this.ogoSubmit = <HTMLButtonElement>this.ogoForm.querySelector( 'button' );
			this.cards = <NodeList>document.querySelectorAll( 'div.cards div.card' );
			this.currentCard = <HTMLDivElement>document.querySelector( 'div.account div.card' );
			
			if ( this.ogoSubmit !== null )
				this.ogoSubmit.addEventListener( 'click', this.ogoSubmitClickHandler.bind(this) );
			
			if ( this.currentCard !== null ){
				this.currentCard.addEventListener( 'click', this.changeBackToPlan.bind(this) );
			}
			
			this.ogoLabel = <HTMLButtonElement>document.querySelector( 'div.ogo>input#ogoshift' );
			this.otherLabel = <NodeList>document.querySelectorAll( 'fieldset.payment-type div>input' );
			if ( this.ogoLabel !== null )
				this.ogoLabel.addEventListener( 'click', this.ogoLabelClickHandler.bind(this) );
			Array.prototype.forEach.call(
				this.otherLabel,
				(item: HTMLInputElement) => {
					item.addEventListener( 'click', this.paymentTypeClickHandler.bind(this) );
				}
			);
			
			// скрытые инпуты
			this.inputTitle = <HTMLInputElement>this.ogoForm.querySelector('input#ogo-title');
			this.inputSite = <HTMLInputElement>this.ogoForm.querySelector('input#ogo-site');
			this.inputId = <HTMLInputElement>this.ogoForm.querySelector('input#ogo-id');
			this.inputEmail = <HTMLInputElement>this.ogoForm.querySelector('input#ogo-email');
			
			// инпуты на втором шаге
			this.inputMainEmail = <HTMLInputElement>document.querySelector('input#input-email');
			this.inputMainLogin = <HTMLInputElement>document.querySelector('input#input-login');
			this.inputMainPass = <HTMLInputElement>document.querySelector('input#input-password');
			
			this.inputMainEmail.addEventListener( 'change', this.inputMainEmailChangeHandler.bind(this) );
			
			Array.prototype.forEach.call(
				this.cards,
				(item: HTMLDivElement) => {
					item.addEventListener( 'click', this.cardClickHandler.bind(this) );
				}
			);
			
			let _self:any = this;
			window.onpopstate = function(event) {
				if ( _self.currentStep == 2 ) _self.changeBackToPlan();
			};
			
			if ( this.inputMainEmail.value !== '' )
				this.inputMainEmailChangeHandler();
		}
	}
	private changeBackToPlan(): void
	{
		(<HTMLDivElement>this.inputMainLogin.parentElement).classList.remove(HIDE);
		(<HTMLDivElement>this.inputMainPass.parentElement).classList.remove(HIDE);
		this.ogoForm.classList.remove(SHOW);
	}
	private cardClickHandler(e: MouseEvent): void
	{
		let card: HTMLDivElement = <HTMLDivElement>e.currentTarget;
		let id: string = (<HTMLButtonElement>card.querySelector( 'button' )).getAttribute( 'data-id' );
		let title: string = (<HTMLHeadingElement>card.querySelector( 'h2' )).innerHTML;
		let siteName: string = this.inputSite.value;
		
		this.inputTitle.value = siteName + ' — ' + title;
		this.inputId.value = id;
	}
	
	private ogoSubmitClickHandler(e: MouseEvent): void{
		if ( ( this.inputMainEmail.parentElement.classList.contains('error') ) || ( this.inputMainEmail.value === '' ) )
		{
			//console.log('error');
		}
		else
		{
			this.ogoForm.submit();
		}
	}
	
	private inputCheckDone(input: HTMLInputElement):void
	{
		if ( input.value != '' )
		{
			input.classList.add('done');
		}
		else
		{
			input.classList.remove('done');
		}
	}
	private inputMainEmailChangeHandler(e?: KeyboardEvent): void {
		this.inputEmail.value = this.inputMainEmail.value;
		
		/*if ( ( this.inputMainEmail.parentElement.classList.contains('error') ) || ( this.inputMainEmail.value !== '' ) )
		{
			console.log('error');
		}*/
	}
	private ogoLabelClickHandler(e: MouseEvent): void
	{
		//console.log('OGO lABEL',this.inputTitle.value,this.inputId.value,this.inputEmail.value);
	}
	private paymentTypeClickHandler(e: MouseEvent): void
	{
		//console.log((<HTMLInputElement>e.currentTarget).id);
		if ( (<HTMLInputElement>e.currentTarget).id !== 'ogoshift' )
		{
			(<HTMLDivElement>this.inputMainLogin.parentElement).classList.remove(HIDE);
			(<HTMLDivElement>this.inputMainPass.parentElement).classList.remove(HIDE);
			this.ogoForm.classList.remove(SHOW);
		}
		else
		{
			(<HTMLDivElement>this.inputMainLogin.parentElement).classList.add(HIDE);
			(<HTMLDivElement>this.inputMainPass.parentElement).classList.add(HIDE);
			this.ogoForm.classList.add(SHOW);
		}
	}
}


